import { render } from "./SideBarNav.vue?vue&type=template&id=103cff28&scoped=true"
const script = {}

import "./SideBarNav.vue?vue&type=style&index=0&id=103cff28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103cff28"]])

export default __exports__